import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import React, { useState } from "react";
import EditMoveInForm from "./EditMoveInForm";
import EditMoveOutForm from "./EditMoveOutForm";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default (props) => {
  const [editData, setEditData] = useState({});

  const open = props.open;
  const editObj = props.editObj;
  const action = props.action;
  const editType = props.editType;
  const properties = props.properties;

  const handleClose = () => {
    setEditData({});
    props.handleClose();
  };

  const onFieldChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const onMeterReadChange = (meterId, value) => {
    setEditData({
      ...editData,
      meterReads: {
        ...(editData.meterReads || {}),
        [meterId]: value,
      },
    });
  };

  const onFieldCheckboxChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.checked == true ? 1 : 0,
    });
  };

  const handleAction = () => {
    action(editObj, editData, editType);
    setEditData({});
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="md"
      keepMounted
      aria-labelledby="edit-move-dialog-title"
      aria-describedby="edit-move-dialog-description"
    >
      <DialogTitle id="edit-move-dialog-title">
        Edit {editType == "movein" ? "Move In" : "Move Out"}
      </DialogTitle>
      <DialogContent>
        {editType == "movein" ? (
          <EditMoveInForm
            key={editObj?.uuid}
            editData={editData}
            onFieldChange={onFieldChange}
            onMeterReadChange={onMeterReadChange}
            moveIn={editObj}
            action={handleAction}
            handleClose={handleClose}
            properties={properties}
            onFieldCheckboxChange={onFieldCheckboxChange}
          />
        ) : (
          <EditMoveOutForm
            key={editObj?.uuid}
            editData={editData}
            onFieldChange={onFieldChange}
            onMeterReadChange={onMeterReadChange}
            moveOut={editObj}
            action={handleAction}
            handleClose={handleClose}
            properties={properties}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
